import { useCallback } from 'react';
import { useAddressCreate } from '~/adapters/services/accounts/postalAddresses/hooks';
import { defaultCountryCode } from '~/adapters/geography/countriesAndProvinces';
import { formStateToDto } from '../mappers';
import { AddressDialog } from './AddressDialog';
import { AddressFormState, DialogProps } from '../types';

const initialAddressState: AddressFormState = {
    firstName: '',
    lastName: '',
    streetAddress: '',
    addressDescription: '',
    postalCode: '',
    addressLocality: '',
    addressRegion: null,
    addressCountry: defaultCountryCode,
    email: '',
    telephone: '',
    addressType: 'residential',
    addressPurpose: 'shipping',
    isDefault: false,
};

export function NewAddressDialog({ open, onClose }: DialogProps) {
    const { mutateAsync, isLoading } = useAddressCreate();
    const onSubmit = useCallback(
        (addressState: AddressFormState) => mutateAsync(formStateToDto(addressState)),
        [mutateAsync],
    );

    return (
        <AddressDialog
            title="Add A New Address"
            open={open}
            onClose={onClose}
            initialAddressState={initialAddressState}
            onSubmit={onSubmit}
            isLoading={isLoading}
        />
    );
}
